import Model from 'flarum/common/Model';
import Tag from 'flarum/tags/common/models/Tag';

export default function () {
  Tag.prototype.blomstraPtpProduct = Model.attribute<string>('blomstra.ptp.product');
  Tag.prototype.blomstraPtvProduct = Model.attribute<string>('blomstra.ptv.product');
  Tag.prototype.blomstraPtvVisibleFrom = Model.attribute<number>('blomstra.ptv.visible_from');
  Tag.prototype.blomstraPtbProduct = Model.attribute<string>('blomstra.ptb.product');
  Tag.prototype.blomstraPtbBumpOthers = Model.attribute<boolean>('blomstra.ptb.bump_others');
  Tag.prototype.blomstraBountyProduct = Model.attribute<string>('blomstra.bounty.product');
}
